import { Controller } from '@hotwired/stimulus';
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['close', 'message']

  connect () {
    enter(this.messageTarget)
    setTimeout(() => {
      leave(this.messageTarget)
    }, 10000);
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect () {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  closeNotification () {
    leave(this.messageTarget)
  }

  handleClickOutside (event) {
    leave(this.messageTarget)
  }
}